import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const FeatureFlagsContext = createContext({
  flags: {},
  loading: true,
  isEnabled: () => true,
  refresh: () => {},
});

export function FeatureFlagsProvider({ children }) {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchFlags = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setFlags({});
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/api/feature-flags/my-flags`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFlags(res.data);
    } catch {
      // Fail open — if flags API fails, treat all as enabled
      setFlags({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  const isEnabled = useCallback((flagKey) => {
    // If flag doesn't exist in the map, default to true (fail open)
    if (!(flagKey in flags)) return true;
    return flags[flagKey];
  }, [flags]);

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, isEnabled, refresh: fetchFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext);
}
